ul{list-style-type:none;display:flex;width:fit-content;padding-left:0}ul li{margin-right:2rem;font-size:18px;cursor:pointer;padding:.3125rem;font-style:normal;color:#2196f3}ul li.highlight{border-bottom:3px solid #212121;font-weight:600;color:#212121}
/*# sourceMappingURL=tabs.component-E2UBAO63.css.map */
